import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const searchSlice = createSlice({
  name: "search",
  initialState: { search: "" },
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
  },
});

// Экшены
export const { setSearch } = searchSlice.actions;

export default searchSlice.reducer;
